import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/MyPurchasedCourse.module.css";
import { Col, Container, Row } from "react-bootstrap";
import clsx from "clsx";
import { TableCustom } from "@components";
import { useSelector } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import { MyPurchasesTab } from "@pages/InstructorCoursesPage/MyPurchasesTab";

const MyPurchasedCourse = (props) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <Container className="p-5 position-relative">
      <h5>
        <i className="bi bi-book mr-2"></i>
        Purchased Courses
      </h5>

      <Row className="mt-5">
        <Col md={12} className="m-0 p-0">
          <MyPurchasesTab />
        </Col>
      </Row>
    </Container>
  );
};

/* required: display name */
MyPurchasedCourse.displayName = "MyPurchasedCourse";

/* required: props types */
MyPurchasedCourse.propTypes = {};

/* required: default props */
MyPurchasedCourse.defaultProps = {};

export { MyPurchasedCourse };
